module.exports = "/images/house-progress.svg?87bf3fbaf3336961c0f25ce0583ab8ae";